import React from "react";
import { BaseLayout } from "@components/components";

export const ServicesBase = () => {
    return <BaseLayout full />;
};
